import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiAutorenew } from '@mdi/js';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Tooltip } from 'antd';
import BaseIcon from '../../../_ui/BaseIcon/BaseIcon';
import BaseButton from '../../../_ui/BaseButton/BaseButton';
import { antNotification } from '../../../mainUtils';

function GeneratePassBtn({
  onClickCallBack,
}) {
  const [isMessageVisible, setIsMessageVisible] = useState(false);

  const timerRef = useRef(null);

  const generatePass = () => {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%&*ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const passwordLength = 12;
    let password = '';
    for (let i = 0; i <= passwordLength; i++) {
      const randomNumber = Math.floor(Math.random() * chars.length);
      password += chars.substring(randomNumber, randomNumber + 1);
    }
    return password;
  };

  const generatePassAndCallBack = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    } else {
      setIsMessageVisible(true);
    }

    timerRef.current = setTimeout(() => {
      setIsMessageVisible(false);
      timerRef.current = null;
    }, 3000);

    onClickCallBack?.(generatePass());
  };

  useEffect(() => () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  return (
    <Tooltip title="The password will be encrypted, copy it now!" open={isMessageVisible} placement="top">
      <BaseButton
        size="small"
        className="btnPrimary-outline"
        onClick={generatePassAndCallBack}
        icon={<BaseIcon className="mr-1" path={mdiAutorenew} size={0.8} />}
      >
        generate pass
      </BaseButton>
    </Tooltip>
  );
}

export default GeneratePassBtn;

GeneratePassBtn.propTypes = {
  onClickCallBack: PropTypes.func,
};
